import React from 'react';
import { motion } from 'framer-motion';
import { Search, MapPin, Briefcase, Dumbbell, Coffee, Clock, ChevronRight } from 'lucide-react';
import { BottomNav } from './BottomNav';
interface HomeScreenProps {
  onNavigate: () => void;
  onTabChange: (tab: 'home' | 'activity' | 'account') => void;
}
export function HomeScreen({
  onNavigate,
  onTabChange
}: HomeScreenProps) {
  const quickDestinations = [{
    name: 'Home',
    icon: MapPin,
    color: 'bg-blue-100 text-blue-600'
  }, {
    name: 'Work',
    icon: Briefcase,
    color: 'bg-slate-100 text-slate-600'
  }, {
    name: 'Gym',
    icon: Dumbbell,
    color: 'bg-orange-100 text-orange-600'
  }, {
    name: 'Coffee',
    icon: Coffee,
    color: 'bg-amber-100 text-amber-600'
  }];
  const recentRides = [{
    name: 'Central Market',
    address: '12 Market St',
    time: 'Yesterday'
  }, {
    name: 'Tech Hub',
    address: '45 Innovation Dr',
    time: '2 days ago'
  }];
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="flex h-full flex-col bg-slate-50" data-id="element-74">
      <div className="flex-1 px-6 pb-24" data-id="element-75">
        {/* Header */}
        <header className="mb-8 mt-4 flex items-center justify-between" data-id="element-76">
          <div data-id="element-77">
            <p className="text-sm font-medium text-slate-500" data-id="element-78">Good morning,</p>
            <h1 className="text-2xl font-bold text-slate-900" data-id="element-79">Alex</h1>
          </div>
          <div className="h-10 w-10 overflow-hidden rounded-full border-2 border-white shadow-sm" data-id="element-80">
            <img src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80" alt="User Avatar" className="h-full w-full object-cover" data-id="element-81" />
          </div>
        </header>

        {/* Search Bar */}
        <motion.button whileTap={{
        scale: 0.98
      }} onClick={onNavigate} className="mb-8 flex w-full items-center gap-3 rounded-2xl bg-white p-4 shadow-sm ring-1 ring-slate-100 transition-shadow hover:shadow-md" data-id="element-82">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-slate-100 text-slate-900" data-id="element-83">
            <Search className="h-5 w-5" data-id="element-84" />
          </div>
          <div className="flex flex-col items-start" data-id="element-85">
            <span className="text-lg font-semibold text-slate-900" data-id="element-86">
              Where to?
            </span>
            <span className="text-xs text-slate-400" data-id="element-87">Search destination</span>
          </div>
        </motion.button>

        {/* Quick Destinations */}
        <section className="mb-8" data-id="element-88">
          <h2 className="mb-4 text-sm font-semibold text-slate-900" data-id="element-89">
            Quick Access
          </h2>
          <div className="grid grid-cols-4 gap-4" data-id="element-90">
            {quickDestinations.map((dest, index) => <motion.button key={dest.name} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: index * 0.05
          }} whileTap={{
            scale: 0.95
          }} onClick={onNavigate} className="flex flex-col items-center gap-2" data-id="element-91">
                <div className={`flex h-14 w-14 items-center justify-center rounded-2xl shadow-sm ${dest.color}`} data-id="element-92">
                  <dest.icon className="h-6 w-6" data-id="element-93" />
                </div>
                <span className="text-xs font-medium text-slate-600" data-id="element-94">
                  {dest.name}
                </span>
              </motion.button>)}
          </div>
        </section>

        {/* Recent Rides */}
        <section data-id="element-95">
          <h2 className="mb-4 text-sm font-semibold text-slate-900" data-id="element-96">
            Recent Rides
          </h2>
          <div className="flex flex-col gap-3" data-id="element-97">
            {recentRides.map((ride, index) => <motion.button key={ride.name} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.2 + index * 0.1
          }} whileTap={{
            scale: 0.98
          }} onClick={onNavigate} className="flex items-center justify-between rounded-2xl bg-white p-4 shadow-sm ring-1 ring-slate-100" data-id="element-98">
                <div className="flex items-center gap-3" data-id="element-99">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-slate-50 text-slate-400" data-id="element-100">
                    <Clock className="h-5 w-5" data-id="element-101" />
                  </div>
                  <div className="text-left" data-id="element-102">
                    <p className="font-semibold text-slate-900" data-id="element-103">{ride.name}</p>
                    <p className="text-xs text-slate-500" data-id="element-104">{ride.address}</p>
                  </div>
                </div>
                <ChevronRight className="h-5 w-5 text-slate-300" data-id="element-105" />
              </motion.button>)}
          </div>
        </section>
      </div>

      <BottomNav activeTab="home" onTabChange={onTabChange} data-id="element-106" />
    </motion.div>;
}